import { useAppSelector } from 'src/hooks';
import TherapyQuestionsDetails from './TherapyQuestionsDetails';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getTherapyQuestionsUseCase,
  saveTherapistAnswersUseCase,
} from 'src/services/therapy/useCases';
import { RootState } from 'src/redux/store';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { QuestionAnswerPayload } from 'src/interfaces/therapyInterface';
import { useNavigate } from 'react-router-dom';

const OnboardingTherapy = () => {
  const dispatch: ThunkDispatch<RootState, unknown, AnyAction> = useDispatch();
  const navigate = useNavigate();

  const { therapyQuestions, completedOnboardingQuestions } = useAppSelector(
    (state) => state.therapy,
  );

  useEffect(() => {
    dispatch(getTherapyQuestionsUseCase());
  }, [dispatch]);

  useEffect(() => {
    if (completedOnboardingQuestions === 'completed') {
      navigate('/Therapist/appointments');
    }
  });

  // Parent component
  // Inside OnboardingTherapy.tsx
  const handleSubmit = (answers: QuestionAnswerPayload[]) => {
    // Check if answers are provided
    const hasEmptyAnswers = answers.some(
      (qa) => qa.answers.length === 0 || qa.answers.some((a) => a.label === ''),
    );
    if (hasEmptyAnswers) {
      // Show error or handle empty answers
      alert('Please provide answers to all questions before submitting.');
      return;
    }
    dispatch(
      saveTherapistAnswersUseCase({
        data: answers,
      }),
    );
  };

  return (
    <div>
      <TherapyQuestionsDetails
        therapyQuestions={therapyQuestions}
        isEditing={false}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default OnboardingTherapy;
